"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelPolicyOrAutomaticRenewalChoiceWidget = void 0;
var React = require("react");
var components_1 = require("@athena-portal/components");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var CancelPolicyOrAutomaticRenewalChoiceWidget = exports.CancelPolicyOrAutomaticRenewalChoiceWidget = /** @class */ (function (_super) {
    __extends(CancelPolicyOrAutomaticRenewalChoiceWidget, _super);
    function CancelPolicyOrAutomaticRenewalChoiceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleCancellationChoice = function (event) {
            var choice = event.target.value;
            var cancelFutureRenewal = choice === CancelPolicyOrAutomaticRenewalChoiceWidget_1.CANCEL_RENEWAL;
            _this.props.onStateChange("uistate.cancelFuturePolicy", cancelFutureRenewal);
            _this.setState({ cancellationChoice: choice });
        };
        _this.state = {
            cancellationChoice: ""
        };
        return _this;
    }
    CancelPolicyOrAutomaticRenewalChoiceWidget_1 = CancelPolicyOrAutomaticRenewalChoiceWidget;
    CancelPolicyOrAutomaticRenewalChoiceWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null, this.renderMotorReasons(this.props.interaction.vehicles[0])));
    };
    CancelPolicyOrAutomaticRenewalChoiceWidget.prototype.renderMotorReasons = function (vehicle) {
        var _this = this;
        var cancellationReasonsKeys = [
            CancelPolicyOrAutomaticRenewalChoiceWidget_1.CANCEL_RENEWAL,
            CancelPolicyOrAutomaticRenewalChoiceWidget_1.CANCEL_OPT_EXISTING_POLICY
        ];
        return (React.createElement("div", { className: "panel cancellation-reason-widget" },
            React.createElement("div", { className: "pt-3 pb-2 font-weight-700 cancellation-reason-question padding-top-32" },
                "When would you like the ",
                vehicle.make,
                ", ",
                vehicle.model,
                " (",
                vehicle.registrationNumber,
                ") policy to end?"),
            React.createElement("div", { className: "d-block input-group margin-top-14 w-100" }, cancellationReasonsKeys.map(function (key) {
                return React.createElement("div", { key: key, className: "custom-control margin-bottom-20-padding-left-0" },
                    React.createElement("input", { className: "custom-radiobutton cursor-pointer", type: "radio", name: "".concat(key), id: "option-".concat(key), value: key, onChange: function (e) { return _this.handleCancellationChoice(e); }, checked: key === _this.state.cancellationChoice }),
                    React.createElement("label", { id: "option-".concat(key, "-label"), className: "checkbox-label driver-label", htmlFor: "option-".concat(key) }, _this.renderChoices(key)));
            }))));
    };
    CancelPolicyOrAutomaticRenewalChoiceWidget.prototype.renderChoices = function (key) {
        if (key === CancelPolicyOrAutomaticRenewalChoiceWidget_1.CANCEL_RENEWAL) {
            return (React.createElement(React.Fragment, null,
                "Cancel on my renewal date (I don't want to renew)",
                React.createElement("p", { className: "fs-14" }, "Select this option if you want to keep your insurance UNTIL your renewal date when this policy will end")));
        }
        else if (key === CancelPolicyOrAutomaticRenewalChoiceWidget_1.CANCEL_OPT_EXISTING_POLICY) {
            return (React.createElement(React.Fragment, null,
                "Cancel before my renewal date",
                React.createElement("p", { className: "fs-14" },
                    "Select this option if you want to cancel BEFORE your renewal date.",
                    React.createElement("br", null),
                    "Note - if you cancel, there'll be a gap in your cover if you have alternative insurance starting on your renewal date")));
        }
        else {
            return null;
        }
    };
    var CancelPolicyOrAutomaticRenewalChoiceWidget_1;
    CancelPolicyOrAutomaticRenewalChoiceWidget.CANCEL_OPT_EXISTING_POLICY = "cancelExistingPolicy";
    CancelPolicyOrAutomaticRenewalChoiceWidget.CANCEL_RENEWAL = "cancelAutomaticRenewal";
    CancelPolicyOrAutomaticRenewalChoiceWidget = CancelPolicyOrAutomaticRenewalChoiceWidget_1 = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], CancelPolicyOrAutomaticRenewalChoiceWidget);
    return CancelPolicyOrAutomaticRenewalChoiceWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=CancelPolicyOrAutomaticRenewalChoiceWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/CancelPolicyOrAutomaticRenewalChoiceWidget.js
// module id = 3236
// module chunks = 0